<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <circle cx="12" cy="9" r="5" stroke="currentColor" stroke-width="1.75" />
  <path
    d="M8.5 14L7 20L12 17.5L17 20L15.5 14"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linejoin="round"
  />
</svg>
